import React from "react";
import { FileText, Eye, Lock, Shield } from "lucide-react";
import { LegalPage } from "../components/LegalPage";

export const PrivacidadPage = () => {
  const sections = [
    {
      id: "1",
      icon: Eye,
      title: "1. Recopilación de Datos",
      body:
        "Al registrarse y adquirir nuestros servicios, OptiShield X recopila información básica necesaria para la facturación y la gestión del panel de control, como correo electrónico, nombre de usuario y cuenta de Discord enlazada.",
    },
    {
      id: "2",
      icon: FileText,
      title: "2. Uso de la Información",
      body: "Los datos recopilados se utilizan exclusivamente para:",
      bullets: [
        "Proveer acceso a los paneles de gestión (credenciales de Pterodactyl, acceso Root/SSH a tus VPS).",
        "Enviar notificaciones sobre el estado del servicio, mantenimientos o caídas (también reflejadas en nuestra página de uptime).",
        "Facturación, prevención de fraudes y soporte técnico a través de tickets.",
      ],
    },
    {
      id: "3",
      icon: Lock,
      title: "3. Seguridad y Protección",
      body:
        "Implementamos medidas de seguridad para proteger tu información contra accesos no autorizados. OptiShield X nunca venderá, compartirá ni alquilará los datos personales, bases de datos o archivos de sus clientes a terceros no autorizados.",
    },
  ];

  return (
    <LegalPage
      title="Política de Privacidad | OptiShield X"
      breadcrumb={[
        { label: "Inicio", to: "/" },
        { label: "Legal" },
        { label: "Privacidad" },
      ]}
      tag={{ icon: Shield, label: "Política de privacidad" }}
      headline={{ prefix: "Política de", accent: "Privacidad" }}
      subtitle="Cómo tratamos, almacenamos y protegemos tu información cuando usas nuestros servicios de hosting, VPS y servidores dedicados."
      lastUpdated={new Date().toLocaleDateString("es-AR", { year: "numeric", month: "long", day: "numeric" })}
      sections={sections}
      ctaTitle="¿Dudas sobre tus datos?"
      ctaDescription="Escribinos por Discord o abrí un ticket desde tu panel de facturación."
      ctaLinks={[
        { label: "Términos y Condiciones", to: "/terminos", testId: "privacidad-terminos-link" },
        { label: "Discord", href: "https://discord.gg/ExE6pGa4df", primary: true, testId: "privacidad-discord-link" },
      ]}
      testIdPrefix="privacidad"
    />
  );
};
